import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from "../modal.component";
import {ModalService} from "../../../data-access/modal.service";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {EscalationService} from "../../../../features/escalation/data-access/escalation.service";
import {NotificationService} from "../../../data-access/notification.service";
import {Userrole} from "../../../interfaces/user";
import {StorageService} from "../../../data-access/storage.service";

@Component({
  selector: 'app-escalation-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './escalation-modal.component.html',
  styleUrls: ['./escalation-modal.component.scss']
})
export class EscalationModalComponent {
  modalService = inject(ModalService);
  formBuilder = inject(FormBuilder);
  escalationService = inject(EscalationService);
  notificationService = inject(NotificationService);

  escalationMessageForm: FormGroup = this.formBuilder.group({
    escalationMessage: ["", Validators.required],
  });

  get escalationMessage() {
    return this.escalationMessageForm.get('escalationMessage')?.value
  }

  onSubmit(targetRole: Userrole) {
    this.escalationService.escalateReport(targetRole, this.escalationMessage);
    /*this.notificationService.showNotification(
        'Die Stillstandsmeldung wurde erfolgreich weitergeleitet'
    )*/
    this.closeModal()
  }

  closeModal() {
    this.modalService.closeModal("escalationModal");
  }

}
